import React from "react";
import "./index.css";
import App from "./App";
import ReactDOM from "react-dom/client";
import "./fonts/poppins/Poppins-Medium.ttf";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
